module.exports = __webpack_public_path__ + "static/media/1POLICY29.05952604.jpg";